import { EmptyCartImg } from '../Assets'
import { toast } from 'react-toastify';
import { useState } from 'react';
import axios from 'axios';

const Form = () => {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')
  const [subject, setSubject] = useState('')
  const [loading, setLoading] = useState(false)

  const submitForm = async (e: any) => {
    e.preventDefault()

    setLoading(true);

    try {

      const sendEmail = await axios.post(`${process.env.REACT_APP_BASE_URL}/contact/email`, {
        name,
        email,
        message,
        subject
      })

      setEmail('');
      setName('');
      setMessage('');
      setSubject('');
      
      return toast.success(sendEmail?.data?.message, {
        position: 'top-left',
        autoClose: 3000,
        toastId: 'form'
      })
    } catch (error) { 
      return toast.error('Failed to send email.', {
        position: 'top-left',
        autoClose: 3000,
        toastId: 'form'
      })

    } finally {
      setLoading(false)
    }
  }
  return (
    <div className="h-full w-full flex items-center flex-col justify-center px-4 bg-primary">
      <img src={EmptyCartImg} alt="not found" className="w-[30%] h-[30%]" />
      <form action="#" className="mb-6 w-full flex itemx-center justify-center gap-y-3 flex-col">
        <div className="">
          <input
            type="text"
            className="form-control block w-full px-4 py-2  text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-orange-600 focus:outline-none"
            placeholder="Your Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div className="">
          <input
            type="text"
            className="form-control block w-full px-4 py-2  text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-orange-600 focus:outline-none"
            placeholder="Email ID"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="">
          <input
            type="text"
            className="form-control block w-full px-4 py-2  text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-orange-600 focus:outline-none"
            placeholder="Subject"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
          />
        </div>
        <div className="">
          <textarea
            className="form-control block w-full min-h-[15vh] px-4 py-2  text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-orange-600 focus:outline-none"
            placeholder="Message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </div>
        <button
          type="submit"
          className="text-white bg-orange-600 hover:bg-orange-700 w-full focus:ring-4 focus:ring-orange-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-orange-600 dark:hover:bg-orange-700 focus:outline-none dark:focus:ring-orange-800 flex items-center justify-center"
          onClick={submitForm}
          disabled={loading} // disable to prevent multiple clicks
        >
          {loading ? (
            <svg
              className="animate-spin h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 100 16v-4l-3 3 3 3v-4a8 8 0 01-8-8z"
              ></path>
            </svg>
          ) : (
            "Send Message"
          )}
        </button>

      </form>
      <p className="cursor-pointer text-sm text-gray-500 dark:text-gray-400">
        <a target='_blank' rel="noreferrer" href="mailto:varagovardan@gmail.com" className="hover:underline">
          varagovardan@gmail.com
        </a>
      </p>
      <p className="text-sm cursor-pointer text-gray-500 dark:text-gray-400">
        <a href="tel:+923218628554" className="hover:underline">
          +92-3218628554
        </a>
      </p>
    </div>
  );
};

export default Form;
